import { useNavigate } from "react-router-dom";
import CustomButton from "../custom-button/custom-button"
import TPremiaCard from "../t-premia-card/t-premia-card"
import { ContentExpiredStyled, TitleStyled } from "./style-component";


const ExpiredMission: React.FC = () => {

	const navigate = useNavigate();	

	const handleExploreCampaigns = () => {
		navigate('/home');
	}

	return (
		<TPremiaCard variant="dark" >
			<ContentExpiredStyled>
				<TitleStyled className="expired-mission">{`Esta misión ha expirado :(`}</TitleStyled>
				<p className="p-expired-mission">Sigue participando en nuevas misiones por grandes recompensas :D</p>
				<div>
					<CustomButton
						onClick={handleExploreCampaigns}
					>
						Explorar campañas
					</CustomButton>
				</div>
			</ContentExpiredStyled>
		</TPremiaCard>
	)
}

export default ExpiredMission;
